import React from "react";
import { Route, Switch } from "react-router";
import ProtectedRoute from "./protectedRoutes";
import MainPage from "../components/Factory/Pages/Common/mainPage";
import forceLogout from "../components/Factory/Pages/Common/forceLogout";
import CallbackPage from "../components/Utils/Oidc/Callback";
import UserProfile from "../components/Factory/Pages/Common/UserProfile";
import ApplicationSettings from "../components/Factory/Pages/Common/ApplicationSettings";
import P_PageLayout from "./../components/Factory/Pages/Common/PageLayout/P_PageLayout";
import PageNotFound from "./PageNotFound";
import homePage from "../components/Factory/Pages/Common/homePage";
// commenting unused routes
// import M_Playground from "../components/Factory/Molecules/Common/M_Playground";
// import Layout from "../components/Factory/Pages/Common/Layouts/M_Layout";
// import M_Layout from "../components/Factory/Pages/Common/Layouts/M_Layout";

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={homePage} />
      <Route path="/callback" component={CallbackPage} />
      <ProtectedRoute path="/dashboard" component={MainPage} />
      <ProtectedRoute path="/securelogout" component={forceLogout} />
      {/* <ProtectedRoute path="/playground" component={M_Playground} />
      <ProtectedRoute path="/cardlayout" component={M_Layout} />
      <ProtectedRoute path="/layout" component={Layout} /> */}
      <ProtectedRoute path="/user_profile" component={UserProfile} />
      <ProtectedRoute path="/app_settings" component={ApplicationSettings} />
      <ProtectedRoute
        path="/:pageUrl/:crmId/:templateId?"
        component={P_PageLayout}
      />
      <Route path="*" component={PageNotFound} />
    </Switch>
  );
}
